import { shortDayLabel } from './DayScrubber/dayScrubberLayout';

import styles from './Filmstrip.module.scss';

export interface DayMarkerProps {
    /** `YYYY-MM-DD`, the calendar day in the location's timezone. */
    day: string;
}

/**
 * Starts a day's run of cards in the strip. Its `data-day` is how the strip works out which
 * days are in view and where to scroll when a day is picked on the scrubber.
 */
export default function DayMarker(props: DayMarkerProps) {
    const { day } = props;

    return (
        <div className={styles.dayMarker} data-day={day}>
            <time dateTime={day}>{shortDayLabel(day, false)}</time>
        </div>
    );
}
